<!--
#########################################################################################
######    Top Navigation Controller TNC10000  :  Contenido Parte Superior          ######
#########################################################################################
-->
<template>

  <div id="igs-subhead">

      <!-- Rotulo Principal -->
      <div class="igs-color0 igs-back-color1 igs-h3">
        <br/>
        <div class="row">
          <div class="col-md-3">
            <router-link to="/">
              <img :src="f99ImageName('logo_ihoreca_blanco')" class="igs-back-color0" width="100">
            </router-link>
          </div>
          <div class="col-md-6 igs-l8 igs-v-center" @click="lp90Copyright">Cuadro de Mando</div>
          <a href="https://www.iprogram.es" target="_new">
            <div class="col-md-3"><img :src="f99ImageName('logo_iprogram_blanco')" height="100"></div>
          </a>
        </div>
        <br/>
      </div>

      <!-- Ámbito y Período -->
      <div class="igs-color1 igs-back-color9 igs-h3">
        <div class="row">
            <div class="col-3 igs-center igs-v-center" @click="lp99RefrescarResultados">
                <div>
                  <span class="igs-l3">Ámbito : </span>
                  <span class="igs-l3 igs-color7">Actividad Total</span>
                </div>
            </div>
            <div class="col-5 igs-center" @click="lp60SWDistribuidorVisible">
              <span class="igs-color2 igs-l3" v-html="ltRotuloDistribuidoresSeleccionados"></span>
            </div>
            <div class="col-4 igs-center igs-v-center">
              <div>
                <span class="igs-l3 igs-center">Período : </span>
                <span class="igs-l3 igs-center igs-color7" @click="swCalendarioVisible = !swCalendarioVisible"><nobr>{{lf91DesdeFechaConsulta}}</nobr> a <nobr>{{lf91HastaFechaConsulta}}</nobr></span>
              </div>
            </div>
        </div>
        <div class="row" v-if="ltListaCompletaDistribuidoresSeleccionados != ''">
          <div class="col-12">
            <span class="igs-color2 igs-l3" v-html="ltListaCompletaDistribuidoresSeleccionados"></span>
          </div>
        </div>
        <div class="row" v-if="swCalendarioVisible">
          <div class="col-md-12 igs-center">
            <date-range-picker  :from="strDesdeFechaConsulta" :to="strHastaFechaConsulta" panel="range" locale="es" :theme="strCalendarioListaImagenColor" @update="lp60ActualizarDHFecha"/>
          </div>
        </div>
        <div class="row" v-if="swDistribuidorVisible">
          <div class="col-md-12">
              <div class="row"><div class="col-12"><br/></div></div>
              <div class="row"><div class="col-12 igs-back-color8">Selecciona los Distribuidores a Consultar</div></div>
              <div class="row">
                <div class="col-12"><br/></div>
              </div>
              <div class="row">
                <div class="col-1">&nbsp;</div>
                <div class="col-10">
                    <vue-select-sides type="mirror" 
                                      placeholder-search-left="Distribuidores Disponibles"
                                      placeholder-search-right="Distribuidores Seleccionados"
                                      v-model="$store.state.strListaDistribuidoresSeleccionados" 
                                     :list="$store.state.strListaDistribuidoresSeleccionables">
                    </vue-select-sides>
                </div>
                <div class="col-1">&nbsp;</div>
              </div>
              <div class="row"><div class="col-12"><br/><button type="button" class="btn igs-back-color8" @click="lp60SWDistribuidorVisible">Cerrar</button><br/><br/></div></div>
          </div>
        </div>

      </div>

  </div>
</template>



<!--
##################################
###########  Código  #############
##################################
-->
<script>
import igs_mixin from '@/igs-mixins/igs_mixin'

import Vuex         from 'vuex'
const mapState      = Vuex.mapState;

export default {
  mixins: [ igs_mixin ],

  //------------------------ Variables Locales  ---------------------------
  data() {
    return {
       //------------------------------------------------------------------------
       //-- Variables Locales
       //------------------------------------------------------------------------
        swCalendarioVisible   : false,
        swDistribuidorVisible : false          
    }
  },

  //--------------------- Propiedades Calculadas  ------------------------
  computed : {

    //-- Mapeo de Variables del Store (para acceso rápido)
    ...mapState(['strDescripcionDistribuidor','strDesdeFechaConsulta','strHastaFechaConsulta','strCalendarioListaImagenColor']),

    //-- Rótulo Principal (Cabecera Lista Distribuidores Seleccionados)
    ltRotuloDistribuidoresSeleccionados() {
      var t1 = "";
    // eslint-disable-next-line  vue/no-side-effects-in-computed-properties
      var listaOrdenada = this.$store.state.strListaDistribuidoresSeleccionados;

      switch (listaOrdenada.length) {
        case 0 : 
          t1 = '-- Seleccione un Distribuidor --';
          break;

        case 1: 
          var r1 = this.$store.state.strListaDistribuidoresSeleccionables.find(registro => {
            return (registro.value == listaOrdenada[0]);
          });

          t1 = r1.label;
          break;

        default :
          t1 = 'Múltiples Distribuidores Seleccionados'
          break;
      }

      return t1;
    },


    //-- Lista de Distribuidores Seleccionados
    ltListaCompletaDistribuidoresSeleccionados() {
      var t1 = "";
    // eslint-disable-next-line  vue/no-side-effects-in-computed-properties
      var listaOrdenada = this.$store.state.strListaDistribuidoresSeleccionados;
      listaOrdenada = listaOrdenada.sort();

      switch (listaOrdenada.length) {
        case 0 : 
          t1 = '';
          break;

        case 1: 
          t1 = '';
          break;

        default :
          listaOrdenada.forEach(element => {

            var r1 = this.$store.state.strListaDistribuidoresSeleccionables.find(registro => {
              return (registro.value == element);
            });

            t1 = t1 + "<span class='badge badge-secondary igs-l3'>" + r1.label + "</span><span class='igs-pad-6'>&nbsp;</span>";
          });
          break;
      }

      return t1;
    },

    //-- Desde Fecha
    lf91DesdeFechaConsulta() {
      return this.f70AMD2fDMA(this.strDesdeFechaConsulta);
    },

    //-- Hasta Fecha
    lf91HastaFechaConsulta() {
      return this.f70AMD2fDMA(this.strHastaFechaConsulta);
    }

  },

  methods: {

    //--------------------------------------------------------------------------------
    //-- Actualizar Nuevo Rango Desde / Hasta Fecha
    //--------------------------------------------------------------------------------
    lp60ActualizarDHFecha(v) {
      //console.dir(v);

      //-- Desde Fecha
      this.$store.commit('p10StrDesdeFechaConsulta', v.from.substring(0,10).replace(/-/g,''));

      //-- Hasta Fecha
      this.$store.commit('p10StrHastaFechaConsulta', v.to.substring(0,10).replace(/-/g,''));

      //-- Ocultar Calendario
      this.swCalendarioVisible = false;

      //-- Refrescar Resultados
      this.lp99RefrescarResultados();

    },


    //---------------------------------------------------------------------------------
    //-- Determinar si se muestra la Lista de Distribuidores (o no)
    //---------------------------------------------------------------------------------
    lp60SWDistribuidorVisible() {
      //console.log(' Lista : '+this.$store.state.strListaDistribuidoresSeleccionables.length);

      //-- Evaluar Número de Elementos Seleccionables
      if (this.$store.state.strListaDistribuidoresSeleccionables.length > 1) {
        //-- Si hay más de un Distribuidor Seleccionable : Permitimos Abrir/Cerrar el selector
        this.swDistribuidorVisible = !this.swDistribuidorVisible;

        //-- Al finalizar la selección ...
        if (!this.swDistribuidorVisible) {
          //-- Reordenar la Lista
          var arr1 = this.$store.state.strListaDistribuidoresSeleccionados;
          this.$store.commit('p10StrListaDistribuidoresSeleccionados', arr1.sort());
          //-- Refrescar
          this.lp99RefrescarResultados();
        }
      } else {
        //-- Cuando hay MENOS de 2 Distribuidores : No mostramos la Lista para Seleccionar Distribuidores a Consultar
        this.swDistribuidorVisible = false;
      }
    },

    //---------------------------------------------------------------------------------
    //-- Mensaje de Copyright
    //---------------------------------------------------------------------------------
    lp90Copyright() {
       this.p99AnuncioIH1('5','7','Información', 'Panel <b>iHoreca</b><br/>Versión <b>'+global.lnkAppVersion+'</b><hr>Copyright (2020)<br/><b><nobr>iProgram Global Software, S.L.</nobr></b>',10);
    },

    //---------------------------------------------------------------------------------
    //-- Refrescar Resultados de los Gráficos
    //---------------------------------------------------------------------------------
    lp99RefrescarResultados() {
      this.$emit('refrescarResultados');
    }


  },


  mounted() {
  }
}
</script>


<!--
##################################
###########  Estilo  #############
##################################
-->
<style>
</style>
